import React from "react";
import {
  StyledStatusLiveStamp,
  StyledStatusExtraStamp,
} from "./StyledStatusLiveStamp";
import { useReactAppState } from "../../../containers/utils";

const StatusLiveStamp = ({
  minuteDisplay = null,
  extraMinutes = null,
  hasPenaltyKicks,
}) => {
  const { t } = useReactAppState();
  if (!minuteDisplay) minuteDisplay = t("live");

  return (
    <StyledStatusLiveStamp>
      {hasPenaltyKicks ? (
        "PKS"
      ) : (
        <>
          {minuteDisplay}
          {!!extraMinutes && (
            <StyledStatusExtraStamp className="mls-c-status-stamp__status--extra">
              +{extraMinutes}
            </StyledStatusExtraStamp>
          )}
        </>
      )}
    </StyledStatusLiveStamp>
  );
};

export default StatusLiveStamp;
